import history from '@/api/history-tracking'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY'),
  object_name: 'All'
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
  SET_OBJECT_NAME(state, name) {
    state.object_name = name
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        object_name: context.state.object_name
      },
      attrubutes
    )
    return history.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  getObj(context) {
    return history.getObj()
  }
}
